<span class="notification-entity" aria-hidden="true">
  @switch (notification().entityType) {
    @case ('tasks') {
      @if (notification().task; as task) {
        <aw-task-checkbox [task]="task" [presentation]="true" />
      } @else {
        <i class="aw-2-icn aw-2-icn--m" awIcon="square-check"></i>
      }
    }
    @case ('projects') {
      @if (notification().project; as project) {
        <aw-project-avatar [project]="project" [square]="true" [size]="'s'" [showLabel]="false" />
      } @else {
        <i class="aw-2-icn aw-2-icn--m" awIcon="folder"></i>
      }
    }
    @case ('documents') {
      <i
        class="aw-2-icn aw-2-icn--m"
        [awIcon]="notification().documentSpace && !notification().document ? 'library' : 'file-text'"
      ></i>
    }
    @case ('filters') {
      <i class="aw-2-icn aw-2-icn--m" awIcon="filter"></i>
    }
    @case ('agents') {
      <i class="aw-2-icn aw-2-icn--m" awIcon="agent"></i>
    }
    @default {
      <i class="aw-2-icn aw-2-icn--m" [awIcon]="notification().icon"></i>
    }
  }
</span>
<span class="notification-copy">
  @if (notificationTitle(); as title) {
    <span class="notification-title">{{ title }}</span>
  } @else {
    <span class="notification-title" [innerHTML]="notificationDescription()"></span>
  }

  @let detail = notification().detail;
  @if (detail) {
    <span class="notification-preview">
      <span [innerHTML]="detail"></span>
      @if (isDueDate() && notification().task && notification().project; as project) {
        <span aria-hidden="true"> · </span>
        <span>{{ project.name }}</span>
      }
    </span>
  }

  <span class="notification-caption">
    @if (!isDueDate() && (activityLabel() || notificationTitle())) {
      <span class="notification-activity">
        @if (author(); as user) {
          <aw-user-avatar aria-hidden="true" [user]="user" [showLabel]="false" [size]="'xxs'" />
        }
        <span>
          @if (activityLabel(); as activity) {
            @if (authorName(); as authorName) {
              <span class="notification-author">{{ authorName }}</span>
            }
            {{ activity }}
          } @else {
            <span [innerHTML]="notificationDescription()"></span>
          }
        </span>
      </span>
      <span aria-hidden="true">·</span>
    }
    <span class="timestamp">{{ notification().createdOn | dateTime: false : true }}</span>
  </span>
</span>
